module.exports = __webpack_public_path__ + "img/service_1.9ad41b43.png";